"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _APButton = _interopRequireDefault(require("../../components/common/APButton"));
var _interestBearingAccountsSelectors = require("../../redux/selectors/interestBearingAccountsSelectors");
var _numberFormatter = require("../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RatesHeading = function RatesHeading(_ref) {
  var history = _ref.history,
    accountStatus = _ref.accountStatus,
    total = _ref.total;
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  if (!accountStatus) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react["default"].createElement("h1", null, t('Start Earning Interest on your Balances')), /*#__PURE__*/_react["default"].createElement("p", null, t('AlphaPoint APEX allows you to automatically lend your balances to a partner liquidity pool to collect highly competitive, daily payouts.')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("p", null, t('Your balances remain in your account, and you will be able to redeem your funds at any time.')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("p", null, t("Don't wait, enable interest now.")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      onClick: function onClick() {
        return history.push('/settings/iba');
      },
      classModifiers: "enable",
      type: "button",
      style: {
        width: '70%'
      },
      customClass: "standalone-form"
    }, t('ENABLE')));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, t("You Are Earning on your Balances")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h2", null, t("So Far, APEX has earned you:")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "rate"
  }, "$", (0, _numberFormatter.formatNumberToLocale)(total, 'USD')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("small", null, t("Approx. notional amount based on current market rates")));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    total: (0, _interestBearingAccountsSelectors.totalInterestPaymentsSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(RatesHeading));